export default "__VITE_ASSET__C_$FD6FR__"